/*eslint-disable react/no-danger*/
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Dialog from "@/components/Dialog"
import ReduxProvider from '@/components/ReduxProvider'
import settings from "@/utils/settings"
import { translate } from "@/utils/translations"

// eslint-disable-next-line react/prop-types
const DigitalLicenseDialog = ({ isShowing, setIsShowing }) => {
  const isCaDisclosureUpdateEnabled = useSelector(
    state => state.featureFlags.caDisclosureUpdateEnabled
  )

  return (
    <Dialog
      heading={translate("digital_license.modal.modal_header")}
      id="digital-license-modal"
      isShowing={isShowing}
      onChangeShow={setIsShowing}
    >
      <Choose>
        <When condition={isCaDisclosureUpdateEnabled} >
          <div
            dangerouslySetInnerHTML={
              {
                __html:
                  translate('digital_license.modal.modal_text_lifetime_client',
                    {
                      supportUrl: settings.vst_support_california_disclosure_url
                    }
                  )
              }
            }
          />

        </When>
        <Otherwise>
          <div>
            {translate('digital_license.modal.modal_text_client')}
            <a
              href={settings.vst_support_california_disclosure_url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {` ${translate('common.support_page')}.`}
            </a>
          </div>
        </Otherwise>
      </Choose>
    </Dialog>
  )
}

// eslint-disable-next-line react/no-multi-comp
const Component = ({
  isShowing, setIsShowing
}) => (
  <ReduxProvider>
    <DigitalLicenseDialog {...{
      isShowing,
      setIsShowing
    }}
    />
  </ReduxProvider>
)

export default Component

Component.propTypes = {
  isShowing: PropTypes.bool,
  setIsShowing: PropTypes.func,
}